module.exports = __webpack_public_path__ + "static/media/laptop.673f793d.jpeg";